export enum SKErrorCode {
    /**
     * Error code indicating that an unknown or unexpected error occurred.
     */
    unknown,

    /**
     * Error code indicating that the client is not allowed to perform the attempted action.
     */
    clientInvalid,

    /**
     * Error code indicating that the user cancelled a payment request.
     */
    paymentCancelled,

    /**
     * Error code indicating that one of the payment parameters was not recognized by the App Store.
     */
    paymentInvalid,

    /**
     * Error code indicating that the user is not allowed to authorize payments.
     */
    paymentNotAllowed,

    /**
     * Error code indicating that the requested product is not available in the store.
     */
    storeProductNotAvailable,

    /**
     * Error code indicating that the user has not allowed access to Cloud service information.
     */
    cloudServicePermissionDenied,

    /**
     * Error code indicating that the device could not connect to the network.
     */
    cloudServiceNetworkConnectionFailed,

    /**
     * Error code indicating that the user has revoked permission to use this cloud service.
     */
    cloudServiceRevoked,
}



// WEBPACK FOOTER //
// ./src/pages/subscriptions/sk-error-code.ts